import React, { Component } from "react";
import { Modal, Input, message } from "antd";
import { changeDomain, autoProduceDomain } from "@api/taobaoDomainChange";
import "./style.less";

const clsPrefix = "changeDomainModal";
class ChangeDomainModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible,
      initDomain: "",
      inputDomain: ""
    };
  }

  handleOk = () => {
    const { inputDomain } = this.state;
    const { initDomain, userId } = this.props;

    if (inputDomain) {
      let data = {
        oldDomain: initDomain,
        newDomain: inputDomain,
        userId
      };
      changeDomain(userId, data).then(() => {
        this.setState({
          visible: false
        });
        this.props.setVisible();
        window.location.reload()
      }).catch( err => {
        message.error('设置失败！')
      })
    } else {
      message.error("域名不能为空，请重新填写！");
    }
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
    this.props.setVisible();
  };

  handleChange(e) {
    let value = e.target.value;
    this.setState({ inputDomain: value });
  }
  autoChangeDomain() {
    const { initDomain, userId } = this.props;
    autoProduceDomain(userId, initDomain).then(res => {
      this.setState({ inputDomain: res.domain });
    }).catch(err=>{
      message.error('自动生成失败')
    });
  }
  render() {
    const { inputDomain } = this.state;
    const { initDomain } = this.props;
    return (
      <Modal
        title='切换域名'
        visible={this.state.visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText='确认'
        cancelText='取消'
        width='664px'
        className={clsPrefix}
      >
        <div className={`${clsPrefix}__item`}>
          <span style={{ marginLeft: "26px" }}> 原域名：</span>
          <span>{initDomain && `${initDomain}.kuaizhan.com`}</span>
        </div>
        <div className={`${clsPrefix}__item`}>
          <span>输入新域名：</span>
          <Input
            style={{ width: 358 }}
            value={inputDomain}
            addonAfter='.kuaizhan.com'
            onChange={e => {
              this.handleChange(e);
            }}
          />
          <span
            className={`${clsPrefix}__item--autoBtn`}
            onClick={this.autoChangeDomain.bind(this)}
          >
            自动生成
          </span>
        </div>
      </Modal>
    );
  }
}
export default ChangeDomainModal;
